// API Configuration
const API_BASE_URL = 
  process.env.NODE_ENV === 'production'
    ? 'https://connectionapi-g2m8.onrender.com'  // Production backend on Render
    : 'http://localhost:8080';  // Local development backend

export default API_BASE_URL;

